var map = {
	"./events/food_balcony.jpeg": 81002,
	"./events/wedding.jpeg": 65755,
	"./events/wedding_dinner.jpeg": 73956,
	"./hotel/background.jpeg": 70718,
	"./hotel/balcony.jpeg": 13266,
	"./hotel/banner_desktop.jpg": 77882,
	"./hotel/banner_desktop_no_logo.jpeg": 1279,
	"./hotel/banner_mobile.jpg": 88310,
	"./hotel/bath_room1.jpeg": 78898,
	"./hotel/bath_room2.jpeg": 88847,
	"./hotel/bathroom.jpeg": 49280,
	"./hotel/bathroom2.jpeg": 56954,
	"./hotel/bathroom3.jpg": 23368,
	"./hotel/beach.jpeg": 83633,
	"./hotel/bg-masthead2.jpg": 70146,
	"./hotel/diving.jpg": 77330,
	"./hotel/entrance.png": 81287,
	"./hotel/frontside.jpeg": 38162,
	"./hotel/frontside2.jpg": 30835,
	"./hotel/hotel.jpg": 90771,
	"./hotel/inside.jpg": 79493,
	"./hotel/inside_day.jpeg": 95267,
	"./hotel/inside_day2.jpeg": 49979,
	"./hotel/inside_sunset.jpeg": 98465,
	"./hotel/inside_xmas.jpeg": 38116,
	"./hotel/pool_closeup.jpeg": 55666,
	"./hotel/pool_day.jpeg": 69589,
	"./hotel/pool_day2.jpeg": 4789,
	"./hotel/pool_day_2.jpeg": 81036,
	"./hotel/pool_day_2_2.jpeg": 62273,
	"./hotel/pool_night.jpeg": 26993,
	"./hotel/sailboat.jpg": 58992,
	"./hotel/scroll_horizontal.png": 5643,
	"./hotel/sunset1.jpg": 74198,
	"./hotel/sunset2.jpg": 7457,
	"./hotel/sunset3.jpg": 29412,
	"./hotel/veranda_day1.jpeg": 63889,
	"./hotel/veranda_day1_2.jpeg": 82880,
	"./hotel/veranda_day2.jpeg": 90192,
	"./hotel/veranda_day3.jpeg": 72327,
	"./hotel/veranda_day4.jpeg": 26142,
	"./hotel/veranda_day5.jpeg": 18629,
	"./hotel/veranda_day_6.jpeg": 19719,
	"./hotel/veranda_sunset.jpeg": 40754,
	"./hotel/veranda_sunset2.jpeg": 79548,
	"./insurance/img.png": 6790,
	"./logo/leaflogo.png": 77423,
	"./logo/logo.svg": 32811,
	"./logo/logo_black.png": 95607,
	"./logo/logo_new.png": 18880,
	"./logo/logo_text.svg": 43803,
	"./logo/logo_white.png": 16913,
	"./logo/logo_with_text.svg": 42620,
	"./logo/logo_with_text_below.svg": 40986,
	"./logo/logo_with_text_white_background.svg": 25185,
	"./logo/logo_with_white_background.svg": 71227,
	"./logo/logoblack.png": 48050,
	"./logo/logowhite.png": 3556,
	"./logo/navlogo.png": 41070,
	"./logo/wordlogo2.png": 43333,
	"./new/DSCF3564.jpg": 18427,
	"./new/DSCF3565.jpg": 47294,
	"./new/DSCF3570.jpg": 94264,
	"./new/DSCF3576.jpg": 39662,
	"./new/DSCF3589.jpg": 63208,
	"./new/DSCF3598.jpg": 21070,
	"./new/DSCF3600.jpg": 64578,
	"./new/DSCF3603.jpg": 77485,
	"./new/DSCF3604.jpg": 96038,
	"./new/DSCF3605.jpg": 34563,
	"./new/DSCF3615.jpg": 82424,
	"./new/DSCF3623.jpg": 18135,
	"./new/DSCF3632.jpg": 46293,
	"./new/DSCF3642.jpg": 84508,
	"./new/DSCF3652.jpg": 6551,
	"./new/DSCF3653.jpg": 35386,
	"./new/DSCF3659.jpg": 94432,
	"./new/DSCF3669.jpg": 4537,
	"./new/DSCF3673.jpg": 90020,
	"./new/DSCF3689.jpg": 98271,
	"./new/DSCF3693.jpg": 61078,
	"./new/DSCF3695.jpg": 64704,
	"./new/balcony.jpg": 30641,
	"./new/drone_pool.jpg": 28762,
	"./new/drone_pool2.jpg": 40138,
	"./new/drone_sea_view.jpg": 70419,
	"./new/drone_sea_view2.jpg": 36665,
	"./new/entrance.jpg": 29619,
	"./new/entrance2.jpg": 4953,
	"./new/palms.jpg": 88342,
	"./new/pool.jpg": 42499,
	"./new/pool10.jpg": 50724,
	"./new/pool11.jpg": 28769,
	"./new/pool2.jpg": 82185,
	"./new/pool3.jpg": 10572,
	"./new/pool4.jpg": 16887,
	"./new/pool5.jpg": 45722,
	"./new/pool6.jpg": 33573,
	"./new/pool7.jpg": 5960,
	"./new/pool8.jpg": 28723,
	"./new/pool9.jpg": 73462,
	"./new/pool_reading_book.jpg": 65996,
	"./new/pool_relaxing.jpg": 51766,
	"./new/pool_sea_view.jpg": 40703,
	"./new/reception.png": 37610,
	"./new/room_sea_view.jpg": 16110,
	"./new/room_sea_view2.jpg": 82662,
	"./new/room_sea_view3.jpg": 72771,
	"./new/room_sea_view4.jpg": 53968,
	"./new/room_sea_view_balcony.jpg": 2255,
	"./new/room_sea_view_balcony2.jpg": 45421,
	"./new/sea_view_day.jpg": 61393,
	"./new/sea_view_sunset.jpg": 30053,
	"./new/sunny_sea_view.jpg": 99530,
	"./new/sunny_sea_view_small.jpg": 87282,
	"./resturant/1.jpg": 30448,
	"./resturant/2.jpg": 14783,
	"./resturant/all_day_menu_1.png": 59065,
	"./resturant/all_day_meny_2.png": 97081,
	"./resturant/breakfast_menu_1.png": 47450,
	"./resturant/breakfast_menu_2.png": 72113,
	"./resturant/starters_menu.png": 45743,
	"./rooms/IMG_0927.jpg": 71347,
	"./rooms/IMG_1052.jpg": 3881,
	"./rooms/bathroom.jpg": 79933,
	"./rooms/bathroom2.jpg": 63555,
	"./rooms/bathroom3.jpg": 25030,
	"./rooms/bathroom4.jpg": 6477,
	"./rooms/bathroom5.jpg": 5552,
	"./rooms/garden_view_ocean_suite/DSC00407.jpg": 20592,
	"./rooms/garden_view_ocean_suite/DSC00417.jpg": 37807,
	"./rooms/mountain_view_king/bathroom.jpeg": 85216,
	"./rooms/mountain_view_king/bed.jpeg": 89625,
	"./rooms/mountain_view_king/desk.jpeg": 83183,
	"./rooms/mountain_view_king/lounge.jpeg": 34560,
	"./rooms/mountain_view_queen/IMG_0941.jpg": 12340,
	"./rooms/mountain_view_queen/IMG_0964.jpg": 56483,
	"./rooms/mountain_view_queen/IMG_0972.jpg": 21970,
	"./rooms/mountain_view_queen/IMG_0977.jpg": 63571,
	"./rooms/ocean_view_king/IMG_1151.jpeg": 31521,
	"./rooms/ocean_view_king/IMG_1153.jpeg": 50935,
	"./rooms/ocean_view_king/IMG_1159.jpeg": 13833,
	"./rooms/ocean_view_king/IMG_1160.jpeg": 40749,
	"./rooms/ocean_view_king/IMG_1161.jpeg": 9414,
	"./rooms/ocean_view_king/IMG_1162.jpeg": 14547,
	"./rooms/ocean_view_king/IMG_1164.jpeg": 39097,
	"./rooms/ocean_view_loft_suite/PHOTO-2023-03-17-10-28-19.jpg": 65320,
	"./rooms/ocean_view_loft_suite/ocean_view_loft_1.jpeg": 16084,
	"./rooms/ocean_view_loft_suite/ocean_view_loft_2.jpeg": 50005,
	"./rooms/ocean_view_loft_suite/ocean_view_loft_3.jpeg": 35374,
	"./rooms/ocean_view_loft_suite/ocean_view_loft_4.jpeg": 37783,
	"./rooms/ocean_view_queen/IMG_0842.jpeg": 60734,
	"./rooms/ocean_view_queen/IMG_0854.jpeg": 73313,
	"./rooms/ocean_view_queen/IMG_0862.jpeg": 24456,
	"./rooms/ocean_view_queen/IMG_0875.jpeg": 35960,
	"./rooms/ocean_view_queen/IMG_0883.jpeg": 52865,
	"./rooms/ocean_view_queen/IMG_0895.jpeg": 21278,
	"./rooms/ocean_view_queen/IMG_0900.jpeg": 5127,
	"./rooms/ocean_view_queen/IMG_0909.jpeg": 88248,
	"./rooms/ocean_view_queen/IMG_0920.jpeg": 6617,
	"./rooms/ocean_view_queen/IMG_0921.jpeg": 75762,
	"./rooms/ocean_view_queen/IMG_0925.jpeg": 76934,
	"./rooms/ocean_view_queen/IMG_0927.jpeg": 29068,
	"./rooms/ocean_view_queen/IMG_0931.jpeg": 25535,
	"./rooms/ocean_view_queen/IMG_0937.jpeg": 23581,
	"./rooms/ocean_view_queen/IMG_1006.jpeg": 67107,
	"./rooms/ocean_view_queen/IMG_1022.jpeg": 14113,
	"./rooms/ocean_view_queen/IMG_1032.jpeg": 7756,
	"./rooms/ocean_view_suite/bathroom.jpeg": 72540,
	"./rooms/ocean_view_suite/bathroom.jpg": 12115,
	"./rooms/ocean_view_suite/bathroom_view.jpg": 22827,
	"./rooms/ocean_view_suite/bed.jpeg": 8893,
	"./rooms/ocean_view_suite/bed2.jpeg": 41965,
	"./rooms/ocean_view_suite/bed2.jpg": 86292,
	"./rooms/ocean_view_suite/bed4.jpg": 94434,
	"./rooms/ocean_view_suite/living_area.jpg": 11520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;